export default "__VITE_ASSET__D3419TRW__"